import { useContext } from 'react';
import { OfficeContext } from '../contexts/contexts';

export function useOffice() {
     const { selectedOffice, handleOfficeChange } = useContext(OfficeContext);
     return { selectedOffice, handleOfficeChange };
}

export function createImageSet(basePath, name) {
     const resolutions = [500, 1000, 1500];
     const images = resolutions.map((res) => ({
          size: res,
          src: basePath + name + res + '.webp',
     }));

     const src = images[0].src;
     const srcset = images.map((img) => `${img.src} ${img.size}w`).join(', ');

     return { src, srcset };
}
